var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadge2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 47.085L6.32789 0L44 29.0321L0 47.085Z",
    fill: "#EE6666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0547 31H13.0703V29.3203L15.9375 26.4219C16.7865 25.5521 17.3411 24.9505 17.6016 24.6172C17.862 24.2786 18.0495 23.9661 18.1641 23.6797C18.2786 23.3932 18.3359 23.0964 18.3359 22.7891C18.3359 22.3307 18.2083 21.9896 17.9531 21.7656C17.7031 21.5417 17.3672 21.4297 16.9453 21.4297C16.5026 21.4297 16.0729 21.5312 15.6562 21.7344C15.2396 21.9375 14.8047 22.2266 14.3516 22.6016L13.0391 21.0469C13.6016 20.5677 14.0677 20.2292 14.4375 20.0312C14.8073 19.8333 15.2109 19.6823 15.6484 19.5781C16.0859 19.4688 16.5755 19.4141 17.1172 19.4141C17.8307 19.4141 18.4609 19.5443 19.0078 19.8047C19.5547 20.0651 19.9792 20.4297 20.2812 20.8984C20.5833 21.3672 20.7344 21.9036 20.7344 22.5078C20.7344 23.0339 20.6406 23.5286 20.4531 23.9922C20.2708 24.4505 19.9844 24.9219 19.5938 25.4062C19.2083 25.8906 18.526 26.5807 17.5469 27.4766L16.0781 28.8594V28.9688H21.0547V31Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge2);
export default __webpack_public_path__ + "static/media/Badge2.0af0d616f8333d480d4a08ec746f4123.svg";
export { ForwardRef as ReactComponent };